import { ChevronLeft, Home } from "lucide-react";
import { Link, useNavigate, type To } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  /**
   * Optional explicit target. When omitted, navigate(-1) is used.
   * Pass `null` to hide the arrow button entirely (home-only row).
   */
  to?: To;
  label?: string;
  /**
   * Show an additional "Главная" home link on the right side. Defaults to
   * true on deep pages; pass `false` when the back target already is /.
   */
  withHome?: boolean;
  className?: string;
}

export function BackButton({
  to,
  label = "Назад",
  withHome = true,
  className,
}: BackButtonProps) {
  const { t } = useTranslation();
  const nav = useNavigate();

  const handleBack = () => {
    if (to !== undefined && to !== null) {
      nav(to);
    } else {
      nav(-1);
    }
  };

  return (
    <div className={cn("flex items-center justify-between gap-3", className)}>
      <button
        type="button"
        onClick={handleBack}
        className="inline-flex items-center gap-1.5 rounded-md border border-cream-border bg-cream-light px-3 py-1.5 text-[13px] font-medium text-navy-deep transition-colors hover:border-amber/50 hover:bg-cream-border/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber/50"
      >
        <ChevronLeft className="h-4 w-4" strokeWidth={2} />
        {label}
      </button>
      {withHome ? (
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-[12px] text-taupe hover:text-navy-deep"
        >
          <Home className="h-3.5 w-3.5" strokeWidth={1.8} />
          {t("nav.home")}
        </Link>
      ) : null}
    </div>
  );
}
